// Constants
import { QueryStringPrimaryKeys } from "constants/urlEnum";

// Utils
import { existFilterInQueryString } from "utils/queryString";

export const parsePageNumberFromUrl = (urlPath: string): number => {
	const pageNumber = existFilterInQueryString(QueryStringPrimaryKeys.PAGE, urlPath)[0];
	return parseInt(pageNumber?.split("=")[1] || "1", 10) - 1;
};
